// extracted by mini-css-extract-plugin
export default {"frame":"GameScreen_frame__xyeFZ","inner":"GameScreen_inner__ioXUf"};